module.exports = __webpack_public_path__ + "makemytrip-logo.png?bbbcdd16face415f5f897c4e70e395fe";